module.exports = __webpack_public_path__ + "img/thumbnail_Wolverine_j_albino.5c1da7be.png";